import { CreateEditQuestionComponent } from '../CreateEditQuestionPage/CreateEditQuestionComponent'
import useHandleEditQuestions from '@/react/hooks/observations/useHandleEditQuestions'
import { ICategory } from '@/react/types/observations'

export const ObservationEditQuestion = () => {
  const {
    isMaxThresholdModal,
    setMaxThresholdModal,
    handleQuestionAdd,
    startingData,
  } = useHandleEditQuestions()

  const handleQuestionAddWrapper = (
    category: ICategory,
    editorContent: string,
  ) => {
    if (!startingData) {
      console.error('Cannot save: startingData is not loaded')
      return
    }
    void handleQuestionAdd(category, editorContent, startingData)
  }

  const handleQuestionAnotherAdd = () => {
    console.log('Another add not implemented for edit mode')
  }

  if (!startingData) {
    return null
  }

  return (
    <CreateEditQuestionComponent
      isMaxThresholdModal={
        typeof isMaxThresholdModal === 'string' ? true : isMaxThresholdModal
      }
      setMaxThresholdModal={(value: boolean) => setMaxThresholdModal(value)}
      handleQuestionAdd={handleQuestionAddWrapper}
      handleQuestionAnotherAdd={handleQuestionAnotherAdd}
      startingData={startingData}
    />
  )
}
